/* Listagem de /collections/all filtrada pelos metafields públicos; sem duplicar catálogo. */
(() => {
  const config = document.getElementById('fs-filter-config');
  if (!config || !/^\/collections\/all\/?$/.test(location.pathname)) return;
  const keys = { fs_jeito: 'jeitos_de_brincar', fs_objetivo: 'objetivos', fs_habilidade: 'habilidades', fs_contexto: 'contexto', fs_formato: 'formato', fs_companhia: 'companhia', fs_ritmo: 'ritmo', fs_gesto_principal: 'gesto_principal', fs_gestos_secundarios: 'gestos_secundarios' };
  const params = new URLSearchParams(location.search);
  const selected = Object.entries(keys).filter(([key]) => params.has(key) && params.get(key));
  const collection = params.get('fs_colecao');
  if (!selected.length && !collection) return;
  const slug = (v) => String(v || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const names = { fs_jeito: 'Jeitos de brincar', fs_objetivo: 'O que você quer apoiar?', fs_habilidade: 'Habilidades', fs_contexto: 'Para profissionais', fs_formato: 'Kits e conjuntos', fs_colecao: 'Brinquedos' };
  const labels = { ...names, fs_companhia: 'Companhia', fs_ritmo: 'Ritmo', fs_gesto_principal: 'Gesto principal', fs_gestos_secundarios: 'Outros gestos' };
  const title = selected.length ? (labels[selected[0][0]] || 'Brinquedos') : names.fs_colecao;
  const endpoint = config.dataset.endpoint;
  const token = config.dataset.token;
  if (!endpoint || !token) return;
  const identifiers = Object.values(keys).map((key) => `{namespace:"florescer",key:"${key}"}`).join(',');
  const query = `query FlorescerFiltros($after:String){products(first:100,after:$after){pageInfo{hasNextPage endCursor} nodes{id handle title availableForSale onlineStoreUrl featuredImage{url altText} priceRange{minVariantPrice{amount currencyCode}} collections(first:30){nodes{handle}} metafields(identifiers:[${identifiers}]){key value}}}}`;
  const readValues = (raw) => { try { const value = JSON.parse(raw); return Array.isArray(value) ? value.map(String) : [String(value)]; } catch { return raw ? [raw] : []; } };
  const match = (item) => selected.every(([param, key]) => {
    const field = item.metafields.find((meta) => meta?.key === key);
    return field && readValues(field.value).some((value) => slug(value) === slug(params.get(param)));
  }) && (!collection || collection.split(',').some((handle) => item.collections.nodes.some((c) => c.handle === handle)));
  const el = (tag, cls, text) => { const node = document.createElement(tag); if (cls) node.className = cls; if (text != null) node.textContent = text; return node; };
  async function start() {
    const main = document.getElementById('MainContent') || document.querySelector('main');
    if (!main) return;
    const shell = el('section', 'fl-filter-list');
    const inner = el('div', 'fl-filter-list__inner');
    const back = el('a', 'fl-filter-list__back', '← Ver todos os brinquedos'); back.href = '/collections/all'; inner.append(back);
    inner.append(el('h1', '', title));
    const status = el('p', 'fl-filter-list__count', 'Buscando produtos…'); status.setAttribute('role', 'status'); inner.append(status);
    const grid = el('div', 'fl-filter-list__grid'); inner.append(grid);
    const more = el('button', 'fl-filter-list__more', 'Ver mais'); more.type = 'button'; more.hidden = true; inner.append(more);
    shell.append(inner); main.before(shell);
    // A listagem nativa continua disponível se a consulta falhar.
    let cursor = null, products = [], hasNext = true;
    try {
      for (let page = 0; hasNext && page < 100; page++) {
        const response = await fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': token }, body: JSON.stringify({ query, variables: { after: cursor } }) });
        if (!response.ok) throw new Error('Consulta indisponível');
        const data = await response.json();
        if (data.errors?.length || !data.data?.products) throw new Error('Consulta indisponível');
        const connection = data.data.products;
        products.push(...connection.nodes.filter(match));
        hasNext = connection.pageInfo.hasNextPage;
        if (hasNext && (!connection.pageInfo.endCursor || connection.pageInfo.endCursor === cursor)) throw new Error('Paginação indisponível');
        cursor = connection.pageInfo.endCursor;
      }
      if (hasNext) throw new Error('Catálogo incompleto');
    } catch {
      main.hidden = true;
      status.textContent = 'Não foi possível carregar esta seleção agora.';
      more.textContent = 'Tentar novamente'; more.hidden = false;
      more.addEventListener('click', () => location.reload());
      return;
    }
    main.hidden = true;
    products.sort((a, b) => a.title.localeCompare(b.title, 'pt-BR'));
    if (selected.length && products.length) {
      const [param, key] = selected[0];
      const first = products[0].metafields.find((field) => field?.key === key);
      const label = first && readValues(first.value).find((value) => slug(value) === slug(params.get(param)));
      if (label) inner.querySelector('h1').textContent = label;
    }
    if (collection && !selected.length) {
      const commercial = { '🌿colecao-jogos': 'Jogos', '🌿-colecao-comidinhas': 'Comidinhas', 'paineis-sensoriais': 'Painéis sensoriais', 'colecao-bichinhos-comiloes-🌿': 'Bichinhos Comilões', '🌿-colecao-brotar-numeros-e-letras': 'Números e letras', 'nomeando-sentimentos-🌿': 'Emoções', '🌿-colecao-rotina': 'Rotina' };
      inner.querySelector('h1').textContent = commercial[collection] || 'Bandejas e acessórios sensoriais';
    }
    status.textContent = `${products.length} ${products.length === 1 ? 'produto encontrado' : 'produtos encontrados'}`;
    if (!products.length) status.textContent = 'Nenhum produto encontrado nesta seleção.';
    let shown = 0;
    const render = () => {
      products.slice(shown, shown + 24).forEach((item) => {
        const card = el('a', 'fl-filter-list__card'); card.href = `/products/${encodeURIComponent(item.handle)}`;
        const media = el('span', 'fl-filter-list__media');
        if (item.featuredImage?.url) { const img = el('img'); img.src = item.featuredImage.url; img.alt = item.featuredImage.altText || item.title; img.loading = 'lazy'; media.append(img); }
        card.append(media, el('span', 'fl-filter-list__title', item.title));
        const price = item.priceRange?.minVariantPrice;
        if (price) card.append(el('span', 'fl-filter-list__price', new Intl.NumberFormat('pt-BR', { style: 'currency', currency: price.currencyCode }).format(Number(price.amount))));
        grid.append(card);
      });
      shown = Math.min(products.length, shown + 24); more.hidden = shown >= products.length;
    };
    more.addEventListener('click', render); render();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();